import Modal from './Modal';

const DocumentInformation = ({ name, isOpen, setIsOpen }) => {
    return (
        <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
            <p>{name}</p>
        </Modal>
    )
}

export default DocumentInformation